import { useEffect, useRef, useState } from "react";
import Scheduledpayments from "../components/scheduledpayments.jsx";
import Processedpayments from "./processedpayments.jsx";
import Returnedpayments from "./returnedpayments.jsx";
import Cancelledpayments from "./cancelledpayments.jsx";
import { GetPayLoad } from "../services/PayLoadStorage";
import Cookies from "js-cookie";
import { postData } from "../services/EncryptService";
import DateRangePickerr from "./dateRangePickerr.jsx";
import { Form, Spinner, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { handleFiservLogin } from "../services/FiservLoginService.jsx"; 

const PaymentHistory = ({ billingContent, genericContent}) => {
    
    const Payload = GetPayLoad('PayLoad');
    
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier,
    };

    const ref = useRef(null);
    const tab1Ref = useRef(null);
    const tab2Ref = useRef(null);
    const tab3Ref = useRef(null);
    const tab4Ref = useRef(null);
    const [apiCallCompleted, setApiCallCompleted] = useState(false);
    const [activeKey, setActiveKey] = useState("tab2");
    const [schedulePayments, setSchedulePayments] = useState([]);
    const [processedPayments, setProcessedPayments] = useState([]);
    const [cancelledPayments, setCancelledPayments] = useState([]);
    const [returnedPayments, setReturnedPayments] = useState([]);
    const [allProcessedPayments, setAllProcessedPayments] = useState([]);
    const [allReturnedPayments, setAllReturnedPayments] = useState([]);
    const [downloadFormat, setDownloadFormat] = useState("pdf");
    const [paymentHistoryErrorFlag, setPaymentHistoryErrorFlag] = useState(false);
    const [isPaymentLoading, setPaymentHistoryLoading] = useState(true);
    const [readOnlyMode, setReadOnlyMode] = useState(false);

    const scheduledpaymentcolumns = [
        billingContent?.billing_payment_scheduled_payments_scheduled_on_text,
        billingContent?.billing_payment_scheduled_payments_scheduled_for_text,
        billingContent?.billing_payment_scheduled_payments_type_text,
        billingContent?.billing_payment_scheduled_payments_account_name_text,
        billingContent?.billing_payment_scheduled_payments_confirmation_no_text,
        billingContent?.billing_payment_scheduled_payments_amount_text,
        billingContent?.billing_payment_scheduled_payments_options_text,
    ];
    const processedpaymentscolumns = [
        billingContent?.billing_payment_processed_payments_processed_date_text,
        billingContent?.billing_payment_processed_payments_type_text,
        billingContent?.billing_payment_processed_payments_account_name_text,
        billingContent?.billing_payment_processed_payments_confirmation_no_text,
        billingContent?.billing_payment_processed_payments_account_no_text,
        billingContent?.billing_payment_processed_payments_amount_text,
    ];
    const returnedpaymentscolumns = [
        billingContent?.billing_payment_returned_payments_return_date_text,
        billingContent?.billing_payment_returned_payments_type_text,
        billingContent?.billing_payment_returned_payments_account_name_text,
        billingContent?.billing_payment_returned_payments_return_code_text,
        billingContent?.billing_payment_returned_payments_return_reason_text,
        billingContent?.billing_payment_returned_payments_account_no_text,
        billingContent?.billing_payment_returned_payments_amount_text,
    ];
    const cancelledpaymentscolumns = [
        billingContent?.billing_payment_cancelled_payments_account_name_text,
        billingContent?.billing_payment_cancelled_payments_account_type_text,
        billingContent?.billing_payment_cancelled_payments_cancelled_date_text,
        billingContent?.billing_payment_cancelled_payments_amount_text,
    ];

     const billingConfirmationLbls = [
        billingContent?.billing_confirmation_title_txt,
        billingContent?.billing_confirmation_subtitle_txt,
        billingContent?.billing_confirmation_transaction_dtls_txt,
        billingContent?.billing_confirmation_confirmation_num_txt,
        billingContent?.billing_confirmation_date_txt,
        billingContent?.billing_confirmation_type_transaction_txt,
        billingContent?.billing_confirmation_status_txt,
        billingContent?.billing_confirmation_schedulefor_txt,
        billingContent?.billing_confirmation_amount_txt,
        billingContent?.billing_confirmation_success_txt,
    ];

    // Fetch Payment History API
    useEffect(() => {
        // Check for read-only mode based on owning carrier or any other condition
        setReadOnlyMode(Payload?.readOnlyAccess === true);

        fetchApiData();
    }, []);

    const fetchApiData = () => {
        
        setActiveKey("tab2");
        const targetUrl = process.env.REACT_APP_API_PAYMENT_HISTORY_ENDPOINT;
        const requestData = new FormData();
        requestData.append("cim", Payload?.cim);
        postData(baseUrl, targetUrl, requestData, headers)
        .then((result) => {
            setPaymentHistoryLoading(false);
            if (result.status && result.data && result.status === 200) {
            let response = result.data;
            if (response && response?.status === "SUCCESS") {
                const result = response;
                setPaymentHistoryErrorFlag(false);
                setSchedulePayments(result?.schedulePayments);
                setProcessedPayments(result?.processedPayments);
                setCancelledPayments(result?.cancelledPayments);
                setReturnedPayments(result?.returnedPayments);
                setAllProcessedPayments(result?.processedPayments);
                setAllReturnedPayments(result?.returnedPayments);
                setApiCallCompleted(true);
            } else {
                setPaymentHistoryErrorFlag(true);
            }
            } else {
            setPaymentHistoryErrorFlag(true);
            }
        })
        .catch((error) => {
            console.log("Payment Config API Failure");
        }); 
    };
    
    // Set Active Tab Based on Button Click
    const handleTabClick = (tabKey) => {
        setActiveKey(tabKey);
    };

    // Handle Date Filter Apply
    const handleApplyDateFilter = (filterType, dateRange) => {
        const { startDate, endDate } = dateRange;
        // Processed Payment
        if (filterType === 1) {
        const filtered = allProcessedPayments?.filter((payment) => {
            const paymentDate = new Date(payment.event_date);
            return paymentDate >= startDate && paymentDate <= endDate;
        });
        setProcessedPayments(filtered);
        }
        // Returned Payment
        else if (filterType === 2) {
        const filtered = allReturnedPayments?.filter((payment) => {
            const paymentDate = new Date(payment.return_date);
            return paymentDate >= startDate && paymentDate <= endDate;
        });
        setReturnedPayments(filtered);
        }
    };

    // Handle Scheduled Payment Download PDF & Excel
    const handleProcessPaymntDownloadPDF = () => {
        // Processed Payment if no record
        if (processedPayments.length === 0) {
            const message =
            billingContent?.billing_payment_auth_nodata_text ||
            "No record available for download.";
            toast.error(message);
            return;
        }

        const displayFlag = 1;
        let downloadFormat = document.querySelector(
            'input[name="ppdownloadFormat"]:checked'
        ).value;
        const displayName = Payload?.displayName;
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const targetCaseUrl = baseUrl + process.env.REACT_APP_API_DOWNLOAD_PAYMENTS_HISTORY_ENDPOINT;
        const currentLang = Cookies.get("lang") || "eng";

        // Create a form element
        const form = document.createElement("form");
        form.method = "POST";
        form.action = targetCaseUrl;
        form.target = "_blank"; // Open in a new tab or window

        // Add form fields
        const fields = {
            cim: Payload?.cim,
            region: Payload?.region,
            case_num: Payload?.case_num,
            owningCarrier: Payload?.owning_carrier,
            downloadFormat: downloadFormat,
            language: currentLang,
            columns: JSON.stringify(processedpaymentscolumns),
            rows: JSON.stringify(processedPayments),
            sitecd: Payload?.site_cd,
            displayFlag: displayFlag,
            displayName: Payload?.displayName,
            pageName: "ProcessedPayments",
            state: Payload?.state || null,
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Carrier": Payload?.owning_carrier,
        };

        for (const key in fields) {
            if (fields[key] !== undefined) {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = fields[key];
            form.appendChild(input);
            }
        }

        // Append the form to the body, submit it, and remove it
        document.body.appendChild(form);
        form.submit();
        if (downloadFormat === "excel") {
            const message =
            genericContent?.excel_download_sucess ||
            "Excel Downloaded Successfully";
            toast.success(message);
        }
        document.body.removeChild(form);
    };

    // Handle Returned Payment Download PDF & Excel
    const handleReturnedPaymentDownload = () => {
        if (returnedPayments.length === 0) {
            const message =
            billingContent?.billing_payment_auth_nodata_text ||
            "No record available for download.";
            toast.error(message);
            return;
        }

        const displayFlag = 1;
        let downloadFormat = document.querySelector(
            'input[name="rpdownloadFormat"]:checked'
        ).value;
        const displayName = Payload?.displayName;
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const targetCaseUrl =
            baseUrl + process.env.REACT_APP_API_DOWNLOAD_PAYMENTS_HISTORY_ENDPOINT;
        const currentLang = Cookies.get("lang") || "eng";

        // Create a form element
        const form = document.createElement("form");
        form.method = "POST";
        form.action = targetCaseUrl;
        form.target = "_blank"; // Open in a new tab or window

        // Add form fields
        const fields = {
            cim: Payload?.cim,
            region: Payload?.region,
            case_num: Payload?.case_num,
            owningCarrier: Payload?.owning_carrier,
            downloadFormat: downloadFormat,
            language: currentLang,
            columns: JSON.stringify(returnedpaymentscolumns),
            rows: JSON.stringify(returnedPayments),
            sitecd: Payload?.site_cd,
            displayFlag: displayFlag,
            displayName: Payload?.displayName,
            pageName: "ReturnedPayments",
            state: Payload?.state || null,
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Carrier": Payload?.owning_carrier,
        };

        for (const key in fields) {
            if (fields[key] !== undefined) {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = fields[key];
            form.appendChild(input);
            }
        }

        // Append the form to the body, submit it, and remove it
        document.body.appendChild(form);
        form.submit();
        if (downloadFormat === "excel") {
            const message =
            genericContent?.excel_download_sucess ||
            "Excel Downloaded Successfully";
            toast.success(message);
        }
        document.body.removeChild(form);
    };

    // Tooltips for Payment Types
    const cancelledtooltip = (
    <Tooltip id="cancelled-payments-tooltip" className="custom-tooltip">
        {billingContent?.billing_payment_cancelled_payments_tooltip_msg}
    </Tooltip>
    );
    const returnedtooltip = (
    <Tooltip id="cancelled-payments-tooltip">
        {billingContent?.billing_payment_returned_payments_tooltip_msg}
    </Tooltip>
    );
    const processedtooltip = (
    <Tooltip id="cancelled-payments-tooltip">
        {billingContent?.billing_payment_processed_payments_tooltip_msg}
    </Tooltip>
    );
    const scheduledtooltip = (
    <Tooltip id="cancelled-payments-tooltip">
        {billingContent?.billing_payment_scheduled_payments_tooltip_msg}
    </Tooltip>
    );

    useEffect(() => {
        if(apiCallCompleted && ref.current){
            setTimeout(() => {
                if (ref.current) {
                    ref.current.focus({ preventScroll: true });
                }
            }, 100);
        }
    }, [apiCallCompleted]);

    // Focus management for tab changes
    useEffect(() => {
        if (apiCallCompleted) {
            let tabRef;
            if (activeKey === 'tab1') tabRef = tab1Ref;
            else if (activeKey === 'tab2') tabRef = tab2Ref;
            else if (activeKey === 'tab3') tabRef = tab3Ref;
            else if (activeKey === 'tab4') tabRef = tab4Ref;

            if (tabRef?.current) {
                setTimeout(() => {
                    if (tabRef.current) {
                        tabRef.current.focus({ preventScroll: true });
                    }
                }, 100);
            }
        }
    }, [activeKey, apiCallCompleted]);

    return (
        <main
        role="main"
        tabIndex="-1" // Make the <main> tag focusable
        ref={ref} // Attach the ref to the <main> tag
        aria-label="Payment History Main Content"
        style={{ outline: 'none' }} // revmove border
        > 
        
            <Modal.Header className={`modal-header ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
            {/* Mobile Dropdown for Q5 Carrier */}
            {Payload?.owning_carrier === 'Q5' && (
                <div className="d-block d-md-none w-100 pb-3" style={{ paddingRight: '40px' }}>
                    <label 
                        htmlFor="payment-type-select"
                        className="q5-payment-type-label"
                        id="payment-type-select-label"
                    >
                        {billingContent?.billing_payment_type_label || 'Payment Type'}
                    </label>
                    <Form.Select 
                        id="payment-type-select"
                        value={activeKey} 
                        onChange={(e) => handleTabClick(e.target.value)}
                        aria-label="Select payment type to view scheduled, processed, returned, or cancelled payments"
                        aria-describedby="payment-type-description"
                        className="payment-type-select"
                        tabIndex={0}
                    >
                        <option value="tab1">
                            {billingContent?.billing_payment_scheduled_payments_title || 'Scheduled Payments'}
                        </option>
                        <option value="tab2">
                            {billingContent?.billing_payment_processed_payments_title || 'Processed Payments'}
                        </option>
                        <option value="tab3">
                            {billingContent?.billing_payment_returned_payments_title || 'Returned Payments'}
                        </option>
                        <option value="tab4">
                            {billingContent?.billing_payment_cancelled_payments_title || 'Cancelled Payments'}
                        </option>
                    </Form.Select>
                    {/* Mobile Tooltip Content Below Dropdown */}
                    {activeKey === 'tab1' && billingContent?.billing_payment_scheduled_payments_tooltip_msg && (
                        <p id="payment-type-description" aria-live="polite" className="payment-tooltip-text">
                            {billingContent.billing_payment_scheduled_payments_tooltip_msg}
                        </p>
                    )}
                    {activeKey === 'tab2' && billingContent?.billing_payment_processed_payments_tooltip_msg && (
                        <p id="payment-type-description" aria-live="polite" className="payment-tooltip-text">
                            {billingContent.billing_payment_processed_payments_tooltip_msg}
                        </p>
                    )}
                    {activeKey === 'tab3' && billingContent?.billing_payment_returned_payments_tooltip_msg && (
                        <p id="payment-type-description" aria-live="polite" className="payment-tooltip-text">
                            {billingContent.billing_payment_returned_payments_tooltip_msg}
                        </p>
                    )}
                    {activeKey === 'tab4' && billingContent?.billing_payment_cancelled_payments_tooltip_msg && (
                        <p id="payment-type-description" aria-live="polite" className="payment-tooltip-text">
                            {billingContent.billing_payment_cancelled_payments_tooltip_msg}
                        </p>
                    )}
                </div>
            )}

            {/* Tab Navigation (Hidden on mobile for Q5, Always shown for other carriers) */}
            <div className={`nav nav-tabs ${Payload?.owning_carrier === 'Q5' ? 'd-none d-md-flex' : ''}`} id="nav-tab" role="tablist" aria-label="Payment history tabs">
                <button className={`nav-link ${activeKey === 'tab1' ? 'active' : ''} me-xl-3`} id="nav-scheduled-tab" 
                data-bs-toggle="tab"
                data-bs-target="#nav-scheduled-panel" type="button" role="tab" 
                aria-controls="nav-scheduled-panel"
                aria-selected={activeKey === 'tab1'}
                onClick={() => handleTabClick('tab1')}
                >
                    <span>
                        {billingContent?.billing_payment_scheduled_payments_title || 'Scheduled Payments'}{' '}
                        <OverlayTrigger placement="bottom" overlay={scheduledtooltip} delay={{ show: 250, hide: 100 }} >
                            <i tabIndex={0} className="fe fe-info" aria-label="Scheduled Payments Info" style={{ cursor: "pointer" }} />
                        </OverlayTrigger>
                    </span>
                </button>

                <button className={`nav-link ${activeKey === 'tab2' ? 'active' : ''} me-xl-3`} id="nav-processed-tab" 
                data-bs-toggle="tab"
                data-bs-target="#nav-processed-panel" type="button" role="tab"
                aria-controls="nav-processed-panel" 
                aria-selected={activeKey === 'tab2'}
                onClick={() => handleTabClick('tab2')}
                >
                    <span className="me-2">
                        {billingContent?.billing_payment_processed_payments_title || 'Processed Payments'}{' '}
                        <OverlayTrigger placement="bottom" overlay={processedtooltip} delay={{ show: 250, hide: 100 }}>
                            <i tabIndex={0} aria-label="Processed Payments Info" className="fe fe-info" style={{ cursor: "pointer" }} />
                        </OverlayTrigger>
                    </span>
                </button>

                <button className={`nav-link ${activeKey === 'tab3' ? 'active' : ''} me-xl-3`} id="nav-returned-tab" 
                data-bs-toggle="tab"
                data-bs-target="#nav-returned-panel" type="button" role="tab" 
                aria-controls="nav-returned-panel"
                aria-selected={activeKey === 'tab3'}
                onClick={() => handleTabClick('tab3')}>
                    <span className="me-2">
                        {billingContent?.billing_payment_returned_payments_title || 'Returned Payments'}{' '}
                    <OverlayTrigger placement="bottom" overlay={returnedtooltip} delay={{ show: 250, hide: 100 }} >
                        <i tabIndex={0} aria-label="Returned Payments Info" className="fe fe-info" style={{ cursor: "pointer" }} />
                    </OverlayTrigger>
                    </span>
                </button>

                <button className={`nav-link ${activeKey === 'tab4' ? 'active' : ''} me-xl-3`} id="nav-cancelled-tab" 
                data-bs-toggle="tab"
                data-bs-target="#nav-cancelled-panel" type="button" role="tab"
                aria-controls="nav-cancelled-panel" 
                aria-selected={activeKey === 'tab4'}
                onClick={() => handleTabClick('tab4')}>
                    <span className="me-2">
                        {billingContent?.billing_payment_cancelled_payments_title || 'Cancelled Payments'}{' '}
                        <OverlayTrigger placement="bottom" overlay={cancelledtooltip} delay={{ show: 250, hide: 100 }} >
                            <i tabIndex={0} aria-label="Cancelled Payments Info" className="fe fe-info" style={{ cursor: "pointer" }} />
                        </OverlayTrigger>
                    </span>
                </button>										
            </div>
        </Modal.Header>
        <Modal.Body>
            {activeKey === "tab1" && (
            <div className="tab-pane fade show active" id="nav-scheduled-panel" role="tabpanel" aria-labelledby="nav-scheduled-tab" ref={tab1Ref} tabIndex="-1" style={{ outline: 'none' }}>
                
                {paymentHistoryErrorFlag && (
                    <div className="api-error-msg">
                    {genericContent?.finance_service_error}
                    </div>
                )}

                {isPaymentLoading && (
                    <div style={{display: "flex",alignItems: "center",gap: "15px",margin: "12px"}}>
                        <Spinner animation="border" role="status"></Spinner>
                        <div style={{ fontSize: "12px" }}>
                            {genericContent?.loading_message}
                        </div>
                    </div>
                )}

                {!isPaymentLoading && !paymentHistoryErrorFlag && schedulePayments &&
                activeKey === "tab1" && (
                    <div className="tab-pane fade show active" id="nav-payments" role="tabpanel" aria-labelledby="nav-scheduled-tab">
                        <div className="d-xl-flex d-md-flex d-block">
                            <div tabIndex={0} className="col-xl-3 col-md-3 mt-xl-margin ps-2 mb-xl-0 mb-md-0 mb-sm-0">
                                <h6 className="paymenthistorymodal">
                                    {schedulePayments?.length}{" "}
                                    {billingContent?.billing_payment_history_transaction_text}
                                    {schedulePayments?.length > 1 ? "(s)" : ""}{" "}
                                    {billingContent?.billing_payment_history_found_text}
                                </h6>
                            </div>
                        </div>
                        <div className="bd-example table-responsive d-grid-tbl billing-tables">
                            <Scheduledpayments columns={scheduledpaymentcolumns} rows={schedulePayments}
                            nodatatext={billingContent?.billing_payment_history_nodata_text} confirmationlbl={billingConfirmationLbls} serviceerror={genericContent?.service_post_error}
                            />
                        </div>
                    </div>
                )}
            </div>
            )}

            {activeKey === "tab2" && (
                <div className="tab-pane fade show active" id="nav-processed-panel" role="tabpanel" aria-labelledby="nav-processed-tab" ref={tab2Ref} style={{ outline: 'none' }}>
                    {paymentHistoryErrorFlag && (
                        <div className="api-error-msg">
                            {genericContent?.finance_service_error}
                        </div>
                    )}

                    {isPaymentLoading && (
                    <div style={{  display: "flex",alignItems: "center",gap: "15px",margin: "12px"}}>
                        <Spinner animation="border" role="status"></Spinner>
                        <div style={{ fontSize: "12px" }}>
                            {genericContent?.loading_message}
                        </div>
                    </div>
                    )}

                    {!isPaymentLoading && !paymentHistoryErrorFlag && processedPayments &&
                        activeKey === "tab2" && (
                        <>
                            <div className="d-xl-flex d-md-flex d-sm-flex d-block">
                                <div  tabIndex={0} className="col-xl-3 col-md-3 mt-xl-margin ps-2 mb-xl-0 mb-md-0 mb-sm-0">
                                <h6 className={`paymenthistorymodal ${Payload?.owning_carrier === 'Q5' ? 'q5-paymenthistory-h6' : ''}`}> 
                                    {processedPayments?.length}{" "}
                                    {billingContent?.billing_payment_history_transaction_text}
                                    {processedPayments?.length > 1 ? "(s)" : ""}{" "}
                                    {billingContent?.billing_payment_history_found_text}
                                    </h6>
                                </div>
                            
                                <div className="col-xl-9 col-md-9 justify-content-end d-block d-sm-flex">
                                    <DateRangePickerr onApplyDateFilter={handleApplyDateFilter} filterType={1} carrier={Payload?.owning_carrier} />

                                    {processedPayments?.length > 0 && (
                                    <div className="d-flex align-items-center ms-2">
                                        <Form.Check
                                        inline
                                        label="PDF"
                                        name="ppdownloadFormat"
                                        type="radio"
                                        id="pdf-radio"
                                        value="pdf"
                                        aria-label="PDF"
                                        defaultChecked
                                        className="payment-download-radio"
                                        onChange={(e) =>
                                        setDownloadFormat(e.target.value)
                                        }
                                        />
                                        <Form.Check
                                        inline
                                        label="Excel"
                                        name="ppdownloadFormat"
                                        type="radio"
                                        id="excel-radio"
                                        value="excel"
                                        aria-label="Excel"
                                        className="payment-download-radio"
                                        onChange={(e) =>
                                        setDownloadFormat(e.target.value)
                                        }
                                        />
                                    </div>
                                    )}

                                    {processedPayments?.length > 0 && (
                                    <button
                                        className={`btn ${Payload?.owning_carrier === 'Q5' ? 'btn-outline-secondary' : 'btn-primary'} ms-1 rounded`}
                                        onClick={() => handleProcessPaymntDownloadPDF()}
                                        aria-label={billingContent?.billing_payment_history_export_pdf_hint}
                                    >
                                        {billingContent?.billing_payment_history_export_pdf_hint}{" "}
                                        {Payload?.owning_carrier !== 'Q5' && (
                                            <i className="fe fe-download"></i>
                                        )}
                                    </button>
                                    )}

                                    {!readOnlyMode && Payload?.owning_carrier === "C4" && (
                                    <button className="btn btn-primary ms-1 rounded" style={{borderRadius: '10px', marginLeft: '5px'}}
                                    onClick={() => handleFiservLogin()}
                                    aria-label={ billingContent?.billing_payment_history_cancel_btntext??"Manage Payment"}>
                                    {billingContent?.billing_payment_history_cancel_btntext??"Manage Payment"}
                                    </button>
                                    )}

                                    </div>
                                </div>

                                <div className="bd-example table-responsive d-grid-tbl billing-tables mb-4">
                                <Processedpayments columns={processedpaymentscolumns} rows={processedPayments}
                                confirmationlbl={billingConfirmationLbls} nodatatext={billingContent?.billing_payment_history_nodata_text} eftwebcontent={billingContent?.billing_payment_type_eft_web_txt}
                                eftcontent={billingContent?.billing_autopay_eft_txt} debitcontent={billingContent?.billing_debit_txt} serviceerror={genericContent?.service_post_error}
                                />
                                </div>
                            </>
                            )}
                        </div>
                    )}

                    {activeKey === "tab3" && (

                    <div className="tab-pane fade show active" id="nav-returned-panel" role="tabpanel" aria-labelledby="nav-returned-tab" ref={tab3Ref} tabIndex="-1" style={{ outline: 'none' }}>
                        {paymentHistoryErrorFlag && (
                        <div className="api-error-msg">
                            {genericContent?.finance_service_error}
                        </div>
                        )}

                        {isPaymentLoading && (
                        <div style={{display: "flex",alignItems: "center",gap: "15px",margin: "12px"}}>
                            <Spinner animation="border" role="status"></Spinner>
                            <div style={{ fontSize: "12px" }}>
                            {genericContent?.loading_message}
                            </div>
                        </div>
                        )}

                        {!isPaymentLoading && !paymentHistoryErrorFlag && returnedPayments &&
                        activeKey === "tab3" && (

                        <div className="tab-pane fade show" id="nav-returned" role="tabpanel" aria-labelledby="nav-returned-tab">
                            <div className="d-xl-flex d-md-flex d-sm-flex d-block">
                                <div tabIndex={0} className="col-xl-3 col-md-3 mt-xl-margin ps-2 mb-xl-0 mb-md-0 mb-sm-0">
                                    <h6 className="paymenthistorymodal">
                                        {returnedPayments?.length}{" "}
                                        {billingContent?.billing_payment_history_transaction_text}
                                        {returnedPayments?.length > 1 ? "(s)" : ""}{" "}
                                        {billingContent?.billing_payment_history_found_text}
                                    </h6>
                                </div>
                                <div className="col-xl-9 col-md-9 justify-content-end d-block d-sm-flex">
                                    
                                    <DateRangePickerr onApplyDateFilter={handleApplyDateFilter} filterType={2} carrier={Payload?.owning_carrier} />
                                    
                                    {returnedPayments?.length > 0 && (
                                    <div className="d-flex align-items-center ms-2">
                                        <Form.Check
                                            inline
                                            label="PDF"
                                            name="rpdownloadFormat"
                                            type="radio"
                                            id="pdf-radio"
                                            value="pdf"
                                            aria-label="PDF"
                                            defaultChecked
                                            className="payment-download-radio"
                                            onChange={(e) =>
                                            setDownloadFormat(e.target.value)
                                            }
                                        />
                                        <Form.Check
                                            inline
                                            label="Excel"
                                            name="rpdownloadFormat"
                                            type="radio"
                                            id="excel-radio"
                                            value="excel"
                                            aria-label="Excel"
                                            className="payment-download-radio"
                                            onChange={(e) =>
                                            setDownloadFormat(e.target.value)
                                            }
                                        />
                                    </div>
                                    )}

                                    {returnedPayments?.length > 0 && (
                                        <button
                                            className={`btn ${Payload?.owning_carrier === 'Q5' ? 'btn-outline-secondary' : 'btn-primary'} ms-1 rounded`}
                                            onClick={() => handleReturnedPaymentDownload()}
                                            aria-label={billingContent?.billing_payment_history_export_pdf_hint}
                                        >
                                            {billingContent?.billing_payment_history_export_pdf_hint}
                                            {" "}
                                            {Payload?.owning_carrier !== 'Q5' && (
                                                <i className="fe fe-download"></i>
                                            )}
                                        </button>
                                    )}

                                    {!readOnlyMode && Payload?.owning_carrier === "C4" && (
                                        <button
                                            className="btn btn-primary ms-1 rounded" style={{borderRadius: '10px', marginLeft: '5px'}}
                                            onClick={() => handleFiservLogin()}
                                            aria-label={
                                            billingContent?.billing_payment_history_cancel_btntext??"Manage Payment"
                                            }
                                        >
                                            {billingContent?.billing_payment_history_cancel_btntext??"Manage Payment"}
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="bd-example table-responsive d-grid-tbl billing-tables mb-4">
                                <Returnedpayments columns={returnedpaymentscolumns} rows={returnedPayments}
                                nodatatext={ billingContent?.billing_payment_history_nodata_text} eftcontent={billingContent?.billing_payment_type_eft_web_txt}
                                />
                            </div>
                            { returnedPayments.length > 0 && (
                            <div className="col-12 text-end mt-3 px-3" style={{ clear: "both" }}>
                                <h6 className="fw-semibold">
                                {
                                    billingContent?.billing_payment_returned_payments_total_amount
                                }{" "}
                                <span className="ms-3">
                                    {returnedPayments?.length > 0
                                    ? returnedPayments?.[0]?.total_return_amount
                                    : "$0.00"}
                                </span>
                                </h6>
                            </div>
                            )}
                        </div>
                        )}
                    </div>
                    )}

                    {activeKey === "tab4" && (

                    <div className="tab-pane fade show active" id="nav-cancelled-panel" role="tabpanel" aria-labelledby="nav-cancelled-tab" ref={tab4Ref} tabIndex="-1" style={{ outline: 'none' }}>
                        {paymentHistoryErrorFlag && (
                        <div className="api-error-msg">
                            {genericContent?.finance_service_error}
                        </div>
                        )}

                        {isPaymentLoading && (
                        <div style={{display: "flex",alignItems: "center",gap: "15px", margin: "12px"}}>
                            <Spinner animation="border" role="status"></Spinner>
                            <div style={{ fontSize: "12px" }}>
                            {genericContent?.loading_message}
                            </div>
                        </div>
                        )}

                        {!isPaymentLoading && !paymentHistoryErrorFlag && cancelledPayments &&
                        activeKey === "tab4" && (

                        <div className="tab-pane fade show" id="nav-cancelled" role="tabpanel"aria-labelledby="nav-cancelled-tab">
                            <div className="d-xl-flex d-md-flex d-block">
                                <div tabIndex={0} className="col-xl-3 col-md-3 mt-xl-margin ps-2 mb-xl-0 mb-md-0 mb-sm-0">
                                    <h6 className="paymenthistorymodal">
                                        {cancelledPayments?.length}{" "}
                                        {billingContent?.billing_payment_history_transaction_text}
                                        {cancelledPayments?.length > 1 ? "(s)" : ""}{" "}
                                        {billingContent?.billing_payment_history_found_text}
                                    </h6>
                                </div>

                                <div className="col-xl-9 col-md-9 justify-content-end d-flex">
                                    {!readOnlyMode && Payload?.owning_carrier === "C4" && (
                                        <button
                                            className="btn btn-primary ms-1 rounded" style={{borderRadius: '10px', marginLeft: '5px'}}
                                            onClick={() => handleFiservLogin()}
                                            aria-label={
                                            billingContent?.billing_payment_history_cancel_btntext??"Manage Payment"
                                            }
                                        >
                                            {billingContent?.billing_payment_history_cancel_btntext??"Manage Payment"}
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="bd-example table-responsive d-grid-tbl billing-tables mb-4">
                                <Cancelledpayments columns={cancelledpaymentscolumns} rows={cancelledPayments}
                                    nodatatext={billingContent?.billing_payment_history_nodata_text} eftcontent={billingContent?.billing_payment_type_eft_web_txt}
                                />
                            </div>
                            </div>
                        )}
                    </div>
                    )}
            </Modal.Body>    
        </main>
    );
}
export default PaymentHistory;